/** Browser-session identity + device metadata for live presence. No personal data. */

const SESSION_KEY = "tqm_presence_session";

export function getPresenceSessionId(): string {
  if (typeof window === "undefined") return "ssr";
  try {
    const existing = window.sessionStorage.getItem(SESSION_KEY);
    if (existing) return existing;
    const id =
      typeof crypto !== "undefined" && "randomUUID" in crypto
        ? crypto.randomUUID()
        : `s_${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
    window.sessionStorage.setItem(SESSION_KEY, id);
    return id;
  } catch {
    return `s_${Math.random().toString(36).slice(2)}`;
  }
}

export type DeviceCategory = "mobile" | "tablet" | "desktop";

export function getDeviceCategory(): DeviceCategory {
  if (typeof navigator === "undefined") return "desktop";
  const ua = navigator.userAgent;
  if (/iPad|Tablet|PlayBook|Silk/i.test(ua) || (/Android/i.test(ua) && !/Mobile/i.test(ua))) {
    return "tablet";
  }
  if (/Mobi|iPhone|Android|iPod|Windows Phone/i.test(ua)) return "mobile";
  return "desktop";
}

/** Short, non-reversible label so admins can group a user's tabs without seeing identity. */
export function shortUserTag(userId: string): string {
  let hash = 5381;
  for (let i = 0; i < userId.length; i += 1) hash = ((hash << 5) + hash + userId.charCodeAt(i)) | 0;
  return `u-${(hash >>> 0).toString(36).slice(0, 6)}`;
}

export type PresenceMeta = {
  sessionId: string;
  kind: "guest" | "member";
  userTag: string | null;
  path: string;
  device: DeviceCategory;
  connectedSince: string;
  updatedAt: string;
};
